import { Dialog, DialogContent, DialogTitle, DialogClose } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { getConfig } from '@/lib/config';
import { formatDateValue } from '@/lib/format-value';

interface AboutDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function AboutDialog({ open, onOpenChange }: AboutDialogProps) {
  const config = getConfig();
  // IC-194: config.buildTimestamp is empty when the deploy didn't stamp one —
  // show "unknown" rather than a fabricated or Invalid Date value. formatDateValue's
  // built-in NaN-safety (see @/lib/format-value) replaces the old Date.parse pre-check.
  const buildDate = formatDateValue(config.buildTimestamp, { invalidDisplay: 'unknown', nullDisplay: 'unknown' });

  return (
    // eslint-disable-next-line no-restricted-syntax -- onOpenChange: DS's Dialog.d.ts is a simplified specimen (onClose, no controlled open state); Nova's is a real controlled Radix Dialog (design-system-redesigns/app-shell-sync-back.md)
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="fixed left-1/2 top-1/2 z-50 w-full max-w-sm -translate-x-1/2 -translate-y-1/2 rounded-lg border border-border bg-surface p-6 shadow-lg focus:outline-none">
        <div className="mb-4">
          <DialogTitle className="font-barlow text-lg font-bold text-foreground">
            About
          </DialogTitle>
        </div>

        <div className="mb-5 flex items-center gap-3">
          <img src="/cct_circle_14.png" alt="CCT" className="h-10 w-10" />
          <div>
            <div className="font-barlow text-base font-bold text-primary">
              Insight Cash
            </div>
            <div className="text-xs text-muted-foreground">
              by CCT &mdash; Casino Cash Trac
            </div>
          </div>
        </div>

        <div className="space-y-2 text-sm">
          <div className="flex justify-between">
            <span className="text-muted-foreground">Version</span>
            <span className="font-mono text-foreground">{config.version}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-muted-foreground">Build Date</span>
            <span className="font-mono text-xs text-foreground" data-testid="about-build-date">
              {buildDate}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="text-muted-foreground">Environment</span>
            <span className="font-mono text-foreground">{config.environment}</span>
          </div>
        </div>

        <div className="my-4 border-t border-border" />

        <div className="text-center text-xs text-muted-foreground">
          <a
            href="https://cct.io"
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium text-primary hover:underline"
          >
            cct.io
          </a>
          <div className="mt-1">
            &copy; {new Date().getFullYear()} CCT. All rights reserved.
          </div>
        </div>

        <DialogClose asChild>
          <Button className="mt-5 w-full">Close</Button>
        </DialogClose>
      </DialogContent>
    </Dialog>
  );
}
